import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-settlementdetail',
  templateUrl: './settlementdetail.page.html',
  styleUrls: ['./settlementdetail.page.scss'],
})
export class SettlementdetailPage implements OnInit {
  @Input() code: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  dataForm: FormGroup;
  constructor(public modalController: ModalController, public alertController: AlertController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'requested_amount': new FormControl(null, [Validators.required])
    });
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  submitForm() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      formData.append(key, value);
    }
    this.restApi.post('settlement', formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.modalController.dismiss({
          'success': true
        });
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

}
